export default __webpack_public_path__ + "static/media/empire_state.6f10e2ed.svg";